<template>
  <div class="yunqiao_wrap">
    <headerBlack-view class="yunqiao_header"></headerBlack-view>
    <img src="@/assets/yunqiao/yunqiao_bg.png" class="yunqiao_bg" />
    <img src="@/assets/yunqiao/left.png" class="left" />
    <img src="@/assets/yunqiao/right.png" class="right" />
    <div class="explain flex-column">
      <img src="@/assets/yunqiao/title.png" />
      <div class="explain_detail">
        “首都带首府”京银合作“互联网+教育”模式，为进一步加强京银两地教育合作，促进首都教育精准帮扶转型升级，
        助力宁夏“互联网+教育”示范区建设，深化“首都教育远程互助工程”。
      </div>
      <br />
      <div>
        创设“互联网+教育”首都师范大学“双优云桥”项目。本项目分为“首师学苑”和“乐智学堂”两个项目群，
        旨在为银川师生提供全新的研学研修教育方式，并形成五大配套工程落地八个实施项目。
      </div>
    </div>
    <div class="construction flex-column">
      <div class="construction_top flex-column">
        <div class="construction_pattern">
          <div>“首都带首府”京银合作“互联网+教育”模式</div>
        </div>
        <div class="arrows01">
          <img src="@/assets/yunqiao/arrows01.png" />
        </div>
        <div class="construction_project">
          <div>首都师范大学“双优云桥”项目</div>
        </div>
        <div class="arrows02">
          <img src="@/assets/yunqiao/arrows02.png" />
        </div>
        <div class="project_wrap flex-align-between">
          <div class="shoushi">首师学院</div>
          <div class="lezhi">乐智学堂</div>
        </div>
      </div>
      <div class="arrows03 flex-align">
        <div class="arrows03_left flex-align-around">
          <img src="@/assets/yunqiao/arrows03.png" />
        </div>
        <div class="arrows03_right flex-align-around">
          <img src="@/assets/yunqiao/arrows01.png" />
        </div>
      </div>
      <div class="project_item flex-align">
        <div class="shoushi_item flex-align-around">“互联网+项目式”学业质量提升工程</div>
        <div class="shoushi_item flex-align-around">“互联网+分享式”一带一路共读工程</div>
        <div class="shoushi_item flex-align-around">“互联网+互动式”同屏共享双师工程</div>
        <div class="shoushi_item flex-align-around">“互联网+全过程”教学行为测评工程</div>
        <div class="lezhi_item flex-align-around">“互联网+混合式”教学技能提升工程</div>
      </div>
      <div class="project_item3 flex-align">
        <div class="shoushi_item flex-align-around">
          <img src="@/assets/yunqiao/arrows01.png" />
        </div>
        <div class="shoushi_item flex-align-around">
          <img src="@/assets/yunqiao/arrows01.png" />
        </div>
        <div class="shoushi_item flex-align-around">
          <img src="@/assets/yunqiao/arrows01.png" />
        </div>
        <div class="shoushi_item flex-align-around">
          <img src="@/assets/yunqiao/arrows01.png" />
        </div>
        <div class="lezhi_item flex-align-around">
          <img src="@/assets/yunqiao/arrows04.png" />
        </div>
      </div>
      <div class="project_item2 flex-layout">
        <div class="shoushi_item flex-align-around">全学科互联网+项目式学习</div>
        <div class="shoushi_item flex-align-around">一带一路共读工程</div>
        <div class="shoushi_item flex-align-around">名校联盟双师课堂</div>
        <div class="shoushi_item flex-align-around">课堂行为大数据分析</div>
        <div class="flex-column">
          <div class="flex-align">
            <div class="shoushi_item flex-align-around">STEAM课程</div>
            <div class="shoushi_item flex-align-around">中小学计算思维培养课程</div>
            <div class="shoushi_item flex-align-around" style="margin-right:0">教室信息化水平提升</div>
          </div>
          <div class="arrows05 flex-align-around">
            <img src="@/assets/yunqiao/arrows05.png" />
          </div>
          <div class="comment flex-align-around">中小学生综合素质评价</div>
        </div>
      </div>
    </div>
    <div class="swiper_wrap">
      <div class="swiper_classify flex-layout">
        <div
          class="shoushi_classify flex-align-around"
          :class="{'active':chooseIndex==1}"
          @mouseenter="mouseenter(1)"
        >首师学院/SHOUSHIXUEYUAN</div>
        <div
          class="lezhi_classify flex-align-around"
          :class="{'active':chooseIndex==2}"
          @mouseenter="mouseenter(2)"
        >乐智学堂/LEZHIXUETANG</div>
      </div>
      <el-carousel
        class="swiper"
        height="382px"
        direction="vertical"
        :autoplay="false"
        v-if="chooseIndex==1"
      >
        <el-carousel-item class="swiper_item">
          <img src="@/assets/yunqiao/shoushi01.png" />
          <div class="item_wrap flex-column">
            <img src="@/assets/yunqiao/01.png" />
            <div class="item_content">
              “名校联盟 双师课堂”项目作为“首都教育远程互助工程”——“首都带首府”京银“互联网+教育”
              首都师范大学双优云桥项目中的核心子项目之一。项目启动将惠及37所中小学学校。项目将以
              京银两地同屏共享课堂，创设学习情境、设置学习任务与计划，使京银两地师生参加同上课、
              同辅导、同测评，同活动，使学习者获得优质课程资源和精准化学习资源，以及经过评测后定制
              化的学习辅导和特色社团服务，使指导者增加相互交流和提升的机会，实现优势互补，不断优化
              处理学习者问题的最佳方案，使学习者与指导者实现实时双向互动,使北京和银川优质教育资源
              互通共享。
            </div>
            <div class="control flex-align">
              <img src="@/assets/yunqiao/prev.png" class="prev" />
              <img src="@/assets/yunqiao/next.png" class="next" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="swiper_item">
          <img src="@/assets/yunqiao/shoushi02.png" />
          <div class="item_wrap flex-column">
            <img src="@/assets/yunqiao/02.png" />
            <div class="item_content">
              STEAM教育的各学科被称之为“元学科”：科学（Science）、技术（Technology）、
              工程（Engineering）和数学（Mathematics）领域的教育，它包括从学前教育到博士
              后教育所有年级水平的教育活动，也包括正式教育（课堂教育）和非正式教育（课外项目）。
              STEAM教育的过程不是把科学、技术、工程和数学知识进行简易叠加，而是强调将多学科自然融合形成新的整体
              ，在学习中要注重学科之间的相互关系与作用。项目针对全国青少年科技创新大赛、中国青少年机器人竞赛、
              全国青少年创意编程与智能设计大赛等权威赛事，
              指导中小学生进行多样化的steam课程学习和社团活动，并协助银川举办steam展示活动。
            </div>
            <div class="control flex-align">
              <img src="@/assets/yunqiao/prev.png" class="prev" />
              <img src="@/assets/yunqiao/next.png" class="next" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="swiper_item">
          <img src="@/assets/yunqiao/shoushi03.png" />
          <div class="item_wrap flex-column">
            <img src="@/assets/yunqiao/03.png" />
            <div class="item_content">
              “课堂行为大数据分析”项目基于大数据的教师专业发展项目利用大数据融合及数据挖掘技术，
              建立了涵盖中小学教师、大学研究者和教学资源的学习共同体，构建了课堂教学行为大数据常
              模数据库集群，能够针对中小学课堂教学进行精准诊断，实现基于数据证据链的课堂教学有效
              性评估，有效帮助中小学教师丰富、改善和重构教师有关如何教与如何支持学生学的实践性知识，
              为学校发展和教师发展提供精准的支持服务。
            </div>
            <div class="control flex-align">
              <img src="@/assets/yunqiao/prev.png" class="prev" />
              <img src="@/assets/yunqiao/next.png" class="next" />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-carousel
        class="swiper"
        height="382px"
        direction="vertical"
        :autoplay="false"
        v-if="chooseIndex==2"
      >
        <el-carousel-item class="swiper_item">
          <img src="@/assets/yunqiao/lezhi01.png" />
          <div class="item_wrap flex-column">
            <img src="@/assets/yunqiao/01.png" />
            <div class="item_content">
              “京银互动一带一路共读工程”以智慧阅读为切入，以师生素养提升为核心，围绕阅读文化、
              阅读资源、阅读课程、跟踪评价工具、阅读活动以及长效化机制多方面、多角度系统化开展，
              营造校园阅读氛围，实现师生的综合发展。以全国性阅读活动为切入，在大数据支持下，充分了解学校阅读基础和需求
              ，通过课堂教学、教师培养、校本书单定制、智能图书共读系统、智能大数据监测终端、
              一带一路的活动等来实现“首都+首府”的教育互联互助。工程将校园阅读跟踪测评系统面向整个银川中小学全部开放。
              基于校园阅读数据监测和反馈，把银川实践相关经验进行总结并整理出版两本专著，协助银川主办全国性的主题学术论坛
              ，打造银川高端论坛的品牌，发布银川市教育局共读白皮书。
            </div>
            <div class="control flex-align">
              <img src="@/assets/yunqiao/prev.png" class="prev" />
              <img src="@/assets/yunqiao/next.png" class="next" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="swiper_item">
          <img src="@/assets/yunqiao/lezhi02.png" />
          <div class="item_wrap flex-column">
            <img src="@/assets/yunqiao/02.png" />
            <div class="item_content">
              “中小学生计算思维培养课程”项目依托由计算思维提出者周以真教授团队所开发的可视化编程语言，
              给宁夏中小学教师和中小学生提供计算思维培养课程《少年AI教程：Kodu编程案例详解》。
              教师在学习课程之后，不仅能够提升自身的科技素养，还能指导中小学生开展可视化编程；学生在学习课程以后
              ，可基于计算思维，提升分析和解决问题的能力，同时激发想象力和创新精神；实现团队合作，锻炼面对公众的表述能力和感染力。
            </div>
            <div class="control flex-align">
              <img src="@/assets/yunqiao/prev.png" class="prev" />
              <img src="@/assets/yunqiao/next.png" class="next" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="swiper_item">
          <img src="@/assets/yunqiao/lezhi03.png" />
          <div class="item_wrap flex-column">
            <img src="@/assets/yunqiao/03.png" />
            <div class="item_content">
              “全学科互联网+项目式学习”项目以中国学生发展6大核心素养：人文底蕴、
              科学精神、学会学习、健康生活、责任担当、实践创新为核心，以双优云桥平台为载体
              ，以课辅测拓为内容，以刷新课程观念、提升知识学习和教材学习的效能为目标，通过“互联网
              +项目学习”的方法，为银川师生提供学科项目式学习课程，一期包括语文、数学、外语、科学实践、
              计算思维等课程，支持学习者与指导者进行合作式自主性学习，通过动手实做，解决生活情境中具有挑战性的问题，
              并将学习成果在平台上公开展示或者在实际情境中真实应用。
            </div>
            <div class="control flex-align">
              <img src="@/assets/yunqiao/prev.png" class="prev" />
              <img src="@/assets/yunqiao/next.png" class="next" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="swiper_item">
          <img src="@/assets/yunqiao/lezhi04.png" />
          <div class="item_wrap flex-column">
            <img src="@/assets/yunqiao/04.png" />
            <div class="item_content">
              “教师信息化水平提升”项目教师信息化水平培训课程以“互联网+新同学”为关系模型，
              结合银川教师专业成长环境下不理想的实际需求，依托教师信息化水平课程，
              为银川教师提供全程陪伴式的教师培训课程。通过7周的在线课程，依托首都师范大学的导师团队
              、师范生助教团队，与银川一线教师共同学习，实现师范生与一线教师专业互助式成长。
            </div>
            <div class="control flex-align">
              <img src="@/assets/yunqiao/prev.png" class="prev" />
              <img src="@/assets/yunqiao/next.png" class="next" />
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item class="swiper_item">
          <img src="@/assets/yunqiao/lezhi05.png" />
          <div class="item_wrap flex-column">
            <img src="@/assets/yunqiao/05.png" />
            <div class="item_content">
              “宁夏中小学生综合素质评价”项目评价维度基于银川本地化的综合素质评价社会实践活动、
              学业成绩（单科 / 总分）、体测成绩（单科 / 总分）、课堂表现、研学旅行、作业表现、
              主观评分等计划模板和荣誉称号、特长等级、任职、处分等非计划模板灵活选择，
              规范综合素质评价工作并简化工作量，实现数据的可视可查。
            </div>
            <div class="control flex-align">
              <img src="@/assets/yunqiao/prev.png" class="prev" />
              <img src="@/assets/yunqiao/next.png" class="next" />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooseIndex: 1
    };
  },
  methods: {
    mouseenter(param) {
      this.chooseIndex = param;
    }
  },
  mounted(){
    window.scroll(0,0)
  },
  activated(){
    window.scroll(0,0)
  }
};
</script>

<style lang="less">
@import "./less/yunqiao.less";
</style>